import { QARoleSelectOptionProps } from 'components/QaRolesCustomSelect/QaRolesCustomSelect.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DATA_ROOM_MEMBER_ROLES } from 'router/subrouters/DataRoom/models/DataRoomMember';
import {
  Q_AND_A_ROLES,
  QAndARoles,
} from 'router/subrouters/DataRoom/models/QAndA';

export default function useOptions() {
  const { t } = useTranslation();

  const sellerRoleOptions = useMemo(
    () => [
      {
        value: DATA_ROOM_MEMBER_ROLES.ADMIN,
        props: {
          title: t('administrator'),
          description: t('administratorDescription'),
        },
      },
      {
        value: DATA_ROOM_MEMBER_ROLES.PUBLISHER,
        props: {
          title: t('publisher'),
          description: t('sellerPublisherDescription'),
        },
      },
      {
        value: DATA_ROOM_MEMBER_ROLES.VIEWER_DOWNLOADER,
        props: {
          title: t('viewAndDwld'),
          description: t('viewAndDwldDescription'),
        },
      },
      {
        value: DATA_ROOM_MEMBER_ROLES.VIEWER,
        props: {
          title: t('viewOnly'),
          description: t('viewOnlyDescription'),
        },
      },
    ],
    [t],
  );

  const buyerRoleOptions = useMemo(
    () => [
      {
        value: DATA_ROOM_MEMBER_ROLES.VIEWER_DOWNLOADER,
        props: {
          title: t('viewAndDwld'),
          description: t('viewAndDwldDescription'),
        },
      },
      {
        value: DATA_ROOM_MEMBER_ROLES.VIEWER,
        props: {
          title: t('viewOnly'),
          description: t('viewOnlyDescription'),
        },
      },
      {
        value: DATA_ROOM_MEMBER_ROLES.PUBLISHER,
        props: {
          title: t('publisher'),
          description: t('buyerPublisherDescription'),
        },
      },
    ],
    [t],
  );

  const sellerQaRole: Array<{
    value: QAndARoles;
    props: QARoleSelectOptionProps;
  }> = useMemo(
    () => [
      {
        value: Q_AND_A_ROLES.ADMIN_SELL,
        props: {
          title: t('qaAdmin'),
          description: t('adminOptionDescription'),
        },
      },
      {
        value: Q_AND_A_ROLES.COORDINATOR,
        props: {
          title: t('co-ordinate'),
          description: t('coordinatorOptDescription'),
        },
      },
      {
        value: Q_AND_A_ROLES.EXPERT,
        props: {
          title: t('expertAnswQ'),
          description: t('expertOptDesc'),
        },
      },
      {
        value: Q_AND_A_ROLES.ANSWER_APPROVER,
        props: {
          title: t('approverOpt'),
          description: t('approverOptDesc'),
        },
      },
      {
        value: Q_AND_A_ROLES.NONE,
        props: {
          title: t('noneOpt'),
          description: t('noneOptDesc'),
        },
      },
    ],
    [t],
  );

  const buyerQaRole: Array<{
    value: QAndARoles;
    props: QARoleSelectOptionProps;
  }> = useMemo(
    () => [
      {
        value: Q_AND_A_ROLES.ADMIN_BUY,
        props: {
          title: t('qaAdminBuy'),
          description: t('qaAdminBuyDecs'),
        },
      },
      {
        value: Q_AND_A_ROLES.QUESTION_APPROVER,
        props: {
          title: t('approverOptBuy'),
          description: t('approverOptBuyDesc'),
        },
      },
      {
        value: Q_AND_A_ROLES.DRAFTER,
        props: {
          title: t('drafterOpt'),
          description: t('drafterOptDesc'),
        },
      },
      {
        value: Q_AND_A_ROLES.NONE,
        props: {
          title: t('noneOpt'),
          description: t('noneOptDesc'),
        },
      },
    ],
    [t],
  );

  return {
    sellerRoleOptions,
    buyerRoleOptions,
    sellerQaRole,
    buyerQaRole,
  };
}
